import { Route, Navigate } from "react-router-dom";
import TutorDashboardPage from "../views/tutor/Dashboard";
import AppointmentsRequests from "../views/tutor/dashboard/AppointmentsRequests";
import ReadersView from "../views/tutor/dashboard/ReadersView";
import RequestsInfo from "../views/tutor/dashboard/Requests";
import TutorSessionsPage from "../views/tutor/dashboard/SessionsView";
import UpcommingSessions from "../views/tutor/dashboard/UpcommingSessions";
import WeeklySchedule from "../views/tutor/dashboard/WeeklySchedule";
import TutorPersonalInfo from "../views/tutor/dashboard/PersonalInfo";
import NewStudentsRequests from "../views/tutor/dashboard/NewStudentsRequests";
import ActiveChatPage from "../views/chat/ActiveChatPage";
import UpdateWeeklySchedule from "../views/tutor/dashboard/WeeklySchedule/UpdateWeeklySchedule";
import FinanceViewPage from "../views/tutor/dashboard/FinanceView";
import TutorStudentProfile from "../views/shared-pages/StudentProfile";
import ChatPageWrapper from "../views/chat/ChatPageWrapper";

export default function TutorRouter() {
  return (
    <Route path="/tutor/dashboard/" element={<TutorDashboardPage />}>
      <Route path="/tutor/dashboard/room/" element={<UpcommingSessions />} />
      <Route
        path="/tutor/dashboard/weekly-schedule"
        element={<WeeklySchedule />}
      />
      <Route
        path="/tutor/dashboard/weekly-schedule/update"
        element={<UpdateWeeklySchedule />}
      />
      <Route path="/tutor/dashboard/sessions" element={<TutorSessionsPage />} />
      <Route
        path="/tutor/dashboard/sessions/:id"
        element={<TutorSessionsPage />}
      />
      <Route path="/tutor/dashboard/readers" element={<ReadersView />} />
      <Route
        path="/tutor/dashboard/personal-info"
        element={<TutorPersonalInfo />}
      />
      <Route path="/tutor/dashboard/requests" element={<RequestsInfo />} />
      <Route
        path="/tutor/dashboard/appointments-requests/:isOutgoingTab"
        element={<AppointmentsRequests />}
      />
      <Route
        path="/tutor/dashboard/financial-dues"
        element={<FinanceViewPage />}
      />
      <Route
        path="/tutor/dashboard/appointments-requests/"
        element={<AppointmentsRequests />}
      />
      <Route
        path="/tutor/dashboard/new-students"
        element={<NewStudentsRequests />}
      />
      <Route
        path="/tutor/dashboard/*"
        element={<Navigate to="/tutor/dashboard/room/" />}
      />
      <Route path="/tutor/dashboard/messages" element={<ChatPageWrapper />} />
      <Route
        path="/tutor/dashboard/student/:id"
        element={<TutorStudentProfile />}
      />

      <Route
        path="/tutor/dashboard/"
        element={<Navigate to="/tutor/dashboard/room/" />}
      />
    </Route>
  );
}
